import React, { useState } from "react";
import { Modal } from "antd";
import { Link } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { useFormik } from "formik";

const AddBrand = ({ onSubmit, title, edit, initialValues }) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    setConfirmLoading(true);
    await formik.submitForm();
    setConfirmLoading(false);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      setConfirmLoading(true);
      await onSubmit(values);
      setConfirmLoading(false);
      setOpen(false);
    },
  });

  return (
    <>
      {edit ? (
        <Link className="me-2 p-2" to="#" onClick={() => setOpen(true)}>
          <i data-feather="edit" className="feather-edit"></i>
        </Link>
      ) : (
        <a onClick={() => setOpen(true)} className="btn btn-added">
          <PlusCircle className="me-2" />
          Добавить
        </a>
      )}
      <Modal
        open={open}
        onHide={() => setOpen(false)}
        title={title}
        onOk={handleOk}
        onCancel={() => setOpen(false)}
        cancelText={"Отмена"}
        confirmLoading={confirmLoading}
        width={"60%"}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col col-lg-12">
              <div className="input-blocks add-product list">
                <label>Бренд</label>
                <input
                  type={"text"}
                  name={"name"}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  className="form-control list"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col col-lg-12">
              <div className="input-blocks add-product list">
                <label>Website</label>
                <input
                  type={"text"}
                  name={"website"}
                  value={formik.values.website}
                  onChange={formik.handleChange}
                  className="form-control list"
                />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AddBrand;
